// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style_formBox__emB5a {
  margin-bottom: 1rem;
}
.style_otpBox__qEr21 {
  margin-bottom: 1rem;
  display: flex;
  justify-content: space-between;
}
.style_otpInput__lJ-0y{
  width: 100%;
  height: 50px;
  font-size: 1rem;
  line-height: 1.5rem;
  font-weight: 500;
  padding:0.75rem;
  border-radius: 0.375rem;
  background: rgb(243, 243, 243);
  border: 1px solid #d3d3d3;
  /* text-align: center; */
}

.style_otpInput__lJ-0y:focus {
  outline: 2px solid rgb(195, 193, 193);
}

.style_forgetText__W-cVP {
  font-size: 12px;
  font-weight: 600;
  color: #5d87ff;
  cursor: pointer;
  text-decoration: none;
}

.style_loginBtn__-loyl {
  background: #5d87ff;
  color: #fff;
  padding: 1rem;
  width: "100%";
  border: none;
  border-radius: 5px;
  font-weight: 500;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/pages/signin/styles/style.module.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,8BAA8B;EAC9B,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB","sourcesContent":[".formBox {\n  margin-bottom: 1rem;\n}\n.otpBox {\n  margin-bottom: 1rem;\n  display: flex;\n  justify-content: space-between;\n}\n.otpInput{\n  width: 100%;\n  height: 50px;\n  font-size: 1rem;\n  line-height: 1.5rem;\n  font-weight: 500;\n  padding:0.75rem;\n  border-radius: 0.375rem;\n  background: rgb(243, 243, 243);\n  border: 1px solid #d3d3d3;\n  /* text-align: center; */\n}\n\n.otpInput:focus {\n  outline: 2px solid rgb(195, 193, 193);\n}\n\n.forgetText {\n  font-size: 12px;\n  font-weight: 600;\n  color: #5d87ff;\n  cursor: pointer;\n  text-decoration: none;\n}\n\n.loginBtn {\n  background: #5d87ff;\n  color: #fff;\n  padding: 1rem;\n  width: \"100%\";\n  border: none;\n  border-radius: 5px;\n  font-weight: 500;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"formBox": `style_formBox__emB5a`,
	"otpBox": `style_otpBox__qEr21`,
	"otpInput": `style_otpInput__lJ-0y`,
	"forgetText": `style_forgetText__W-cVP`,
	"loginBtn": `style_loginBtn__-loyl`
};
export default ___CSS_LOADER_EXPORT___;
